export default __webpack_public_path__ + "static/media/bg_wave.6d577014.png";